module.exports = __webpack_public_path__ + "img/qukuailian_list4.c2512d6a.png";